declare global {
  interface Array<T> {
    containsEthereumAddress(address: string): boolean;
  }
}

Array.prototype.containsEthereumAddress = function (address: string) {
  return this.map((x) => x.toString().toLowerCase()).includes(
    address.toLowerCase()
  );
};

export {};
